var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { lazy, Suspense, useMemo } from 'react';
import { defaultLoadingFallback } from './fallbacks';
export const Await = ({ promises, fallback = defaultLoadingFallback, children, }) => {
    const Lazy = useMemo(() => lazy(() => __awaiter(void 0, void 0, void 0, function* () {
        yield Promise.all(promises);
        return {
            default: ({ children }) => children,
        };
    })), [promises]);
    return (_jsx(Suspense, Object.assign({ fallback: fallback }, { children: _jsx(Lazy, { children: children }) })));
};
//# sourceMappingURL=await.js.map